import { useState } from "react"
import PropTypes from "prop-types"

import StepDetails from "./step_details"
import { fetchActivityDetail } from "./api"
import "./styles.scss"

const ActivitySteps = ({ applet, activityId }) => {
  const [runDetails, setRunDetails] = useState(null)
  const [fetched, setFetched] = useState(false)

  const fetchRunDetails = async () => {
    if (!fetched) {
      const event = await fetchActivityDetail(activityId)
      setFetched(true)

      setRunDetails(event.grizzly.run_details)
    }
  }

  return (
    <div styleName="activity-steps">
      {applet.permissions.map((step, i) => (
        <StepDetails
          key={step.id}
          fetchRunDetails={fetchRunDetails}
          finalStep={applet.permissions.length === i + 1}
          detailsForStep={runDetails?.find(
            stepDetail => stepDetail.permission_id === step.id
          )}
          brand_color={step.brand_color}
          icon_url={step.icon_url}
          id={step.id}
          name={step.name}
          service_name={step.service_name}
        />
      ))}
    </div>
  )
}

ActivitySteps.propTypes = {
  applet: PropTypes.object,
  activityId: PropTypes.string.isRequired,
}

export default ActivitySteps
